module.exports = __webpack_public_path__ + "c0799ebf1d583d0d38408484bb56ec44.svg";